import { TuitionNavbarComponent } from './tuition-navbar.component';
import { NgModule } from '@angular/core';
import { EdAssistUINavbarModule } from '@edassist-ui/navbar';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ProfileActionsDropdownModule } from '../profile-actions';
import { SupportServicesModule } from '../support-services';
import { OtherServicesModule } from '../other-services';
import { EdAssistUIHeaderModule } from '@edassist-ui/header';
import { EdAssistUIClientLogoModule } from '@edassist-ui/client-logo';
import { EdAssistUIPipesModule, StripHtmlPipe } from '@edassist-ui/pipes';
import { StartApplicationButtonModule } from '@tuition/shared/components/start-application-button/start-application-button.module';

const COMPONENTS = [TuitionNavbarComponent];

@NgModule({
	imports: [
		EdAssistUINavbarModule,
		CommonModule,
		RouterModule,
		NgbTooltipModule,
		ProfileActionsDropdownModule,
		SupportServicesModule,
		OtherServicesModule,
		EdAssistUIHeaderModule,
		EdAssistUIClientLogoModule,
		EdAssistUIPipesModule,
		CommonModule,
		RouterModule,
		NgbTooltipModule,
		StartApplicationButtonModule
	],
	providers: [StripHtmlPipe],
	exports: COMPONENTS,
	declarations: COMPONENTS
})
class TuitionNavbarModule {}

export { TuitionNavbarModule, TuitionNavbarComponent };
